module.exports = __webpack_public_path__ + "media/images/icon__burger-menu@3x-002fc67286a896919ddbae9538a2b0b3.png";